import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import classNames from 'lib/util/classNames'
import styles from './Container.module.scss'

/**
 * The `Container`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Container (props) {
  const { children, className, size } = props
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.container,
        styles[`size-${normalizeSizeString(size)}`]
      ]),
    [size]
  )

  return <div className={classNameOutput}>{children}</div>
}

/** @type {object} */
Container.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node
}

/** @type {object} */
Container.defaultProps = {
  className: '',
  size: 'standard',
  children: []
}

// Memoize
export default memo(Container)
